module.exports = require('./lib/axios');


/*****************
 ** WEBPACK FOOTER
 ** ./~/axios/index.js
 ** module id = 133
 ** module chunks = 0
 **/